import { render, staticRenderFns } from "./WHome.vue?vue&type=template&id=70dc6168&scoped=true"
import script from "./WHome.vue?vue&type=script&lang=js"
export * from "./WHome.vue?vue&type=script&lang=js"
import style0 from "./WHome.vue?vue&type=style&index=0&id=70dc6168&prod&lang=css"
import style1 from "./WHome.vue?vue&type=style&index=1&id=70dc6168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc6168",
  null
  
)

export default component.exports